import { Component } from '@angular/core';

@Component({
  selector: 'sh-auth-callback-page',
  template: ``,
  standalone: false
})
export class CallbackPageComponent {
  // NOTE: keep this as simple as it is now, do not add any logic here
  // the callback URL is used only to process code and state in order to retrieve an actual token
}
